import store from './store.js';
import { v4 as uuidv4 } from 'uuid';

import { bookmarksAPI } from './communication/bookmarks';
import { interactionEventsTracker } from './communication/analytics';

export default {
    id: null,
    uuid: null,

    // 'pdf' | 'epub'
    type: null,
    // PDF page number; for EPUB the printed page (derived from doc-pagebreak markers),
    // falling back to the Readium position for fixed-layout / unmarked EPUBs. EPUB matching
    // uses the locator's progression, not this field.
    page: null,
    // EPUB only: serialized RWPM Locator (href/type/title/locations) for goToLocation.
    locator: null,

    create() {
        this.uuid = uuidv4();
    },

    async store() {
        const response = await bookmarksAPI.store({
            uuid: this.uuid,
            type: this.type,
            page: this.page,
            locator: this.locator,
        });
        this.id = response.id;
        store.state.bookmarks.push(this);
        interactionEventsTracker.track('bookmark', 'create', this.id);
    },

    /**
     * Deletes the bookmark on the host. Mirrors flashcardModel.destroy: the caller only
     * removes it from the store once this resolves true, so a failed DELETE does not leave
     * the UI out of sync with the backend.
     * @returns {Promise<boolean>} True if the delete succeeded, false on failure.
     */
    async destroy() {
        try {
            await bookmarksAPI.delete(this.id);
            return true;
        } catch (e) {
            console.error('bookmark destroy failed', e);
            return false;
        }
    },
};
